import { createContext } from "react";

// True while GuardianGate shows the advisory guardian banner above the app.
// The gate then owns the viewport: the banner takes what it needs and the app
// gets the rest, so full-height screens (the assistant chat) size to that rest
// instead of the whole viewport and keep their input on screen.
export const GuardianAdvisoryContext = createContext(false);
